import { Button } from 'components/global/Button'
import { scrollLock } from 'components/global/scrollLock'
import {
    getCookie,
    setCookie,
} from '@kakadu-dev/base-frontend-helpers/helpers/Cookie'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import styles from './styles.scss'

const EXPIRES_SEC = 86400 * 1; // 1 day
const HREF = 'https://gum-base.s3.gum.by/prod/gum/static-pages/docs/isec/cookie-policy.pdf';

export const CookieBanner = ({ onConsentGiven }) => {
    const [visible, setVisible] = useState(false);
    const [isShow, setIsShow] = useState(false);

    useEffect(() => {
        const consent = getCookie(`cookieConsent`);
        if (consent === 'true') {
            typeof onConsentGiven === 'function' && onConsentGiven()
        } else if (consent !== 'false') {
            setVisible(true)
        }
    }, [onConsentGiven])

    useEffect(() => {
        if (visible) {
            scrollLock(true);
            const timeoutId = setTimeout(() => setIsShow(true), 25);
            return () => clearTimeout(timeoutId)
        }
    }, [visible])

    const onClickHandle = (isAccept) => {
        setCookie('cookieConsent', isAccept ? 'true' : 'false', true, { expires: EXPIRES_SEC })
        if (isAccept && typeof onConsentGiven === 'function') {
            onConsentGiven()
        }
        scrollLock(false)
        setVisible(false)
    }

    if (!visible) return null

    return (
        <div className={styles.banner}>
            <div className={styles.banner_container + (isShow ? ` ${styles.show}` : '')}>
                <b>Наш сайт использует файлы cookie для сбора статистики</b>
                <span>Нажав «Принять», вы даёте согласие на обработку файлов cookie</span>
                <div>
                    <Button
                        type="button"
                        title="Отклонить"
                        style={styles.button_discard}
                        onClick={() => onClickHandle(false)}
                    />
                    <Button
                        type="button"
                        title="Принять"
                        style={styles.button_allow}
                        color={'green'}
                        onClick={() => onClickHandle(true)}
                    />
                </div>
                <small className={styles.banner_link}>Вы можете ознакомиться с <a href={HREF} target='_blank' rel="noopener noreferrer">Политикой обработки файлов cookie</a></small>
            </div>
        </div >
    )
}

CookieBanner.propTypes = {
    onConsentGiven: PropTypes.func,
}

CookieBanner.defaultProps = {
    onConsentGiven: () => null,
}